import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ENT_NIVELES_ACADEMICOS,
  ALL_ENT_NIVELES_ACADEMICOS,
  LOADING_ALL_ENT_NIVELES_ACADEMICOS,
} from './EntNivelesAcademicosReducer';
import {
  allEntNivelesAcademicosService,
  deleteEntNivelesAcademicosService,
  oneEntNivelesAcademicosService,
  saveEntNivelesAcademicosService,
} from './EntNivelesAcademicosService';

export const allEntNivelesAcademicosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENT_NIVELES_ACADEMICOS, payload: true });
    const res = await allEntNivelesAcademicosService(params);
    dispatch({ type: ALL_ENT_NIVELES_ACADEMICOS, payload: res.data });
    dispatch({ type: LOADING_ALL_ENT_NIVELES_ACADEMICOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENT_NIVELES_ACADEMICOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntNivelesAcademicosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntNivelesAcademicosService(id, data);
    notify(res.data.message);
    await allEntNivelesAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntNivelesAcademicosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENT_NIVELES_ACADEMICOS, payload: data });
};

export const oneEntNivelesAcademicosAction = async (dispatch, id) => {
  try {
    const res = await oneEntNivelesAcademicosService(id);
    await setActivoEntNivelesAcademicosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntNivelesAcademicosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntNivelesAcademicosService(id);
    notify(res.data.message);
    await setActivoEntNivelesAcademicosAction(dispatch, null);
    await allEntNivelesAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
